// Type guards for DICOM domain types
import { DicomDose } from './dicomDose';
import { DicomStructureSet } from './dicomstructureset';
import { DicomPlan } from './dicomPlan';
import { DicomRigidRegistration } from './dicomRigidRegistration';

export function isDose(obj: unknown): obj is DicomDose {
    return obj instanceof DicomDose;
}

export function isDicomStructureSet(obj: unknown): obj is DicomStructureSet {
    return obj instanceof DicomStructureSet;
}

export function isDicomPlan(obj: unknown): obj is DicomPlan {
    return obj instanceof DicomPlan;
}

export function isDicomRigidRegistration(
    obj: unknown
): obj is DicomRigidRegistration {
    return obj instanceof DicomRigidRegistration;
}
